import React from 'react';
import { motion } from 'framer-motion';
import LogoCarousel from './LogoCarousel';
import ApplyButton from './ApplyButton';
interface LogoSectionProps {
  scrollToCalendar?: () => void;
}
const LogoSection = ({
  scrollToCalendar
}: LogoSectionProps) => {
  return <section className="w-full bg-black py-6 px-4" data-id="element-167">
      <div className="max-w-7xl mx-auto" data-id="element-168">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="text-center" data-id="element-169">
          <h3 className="text-center text-base sm:text-lg md:text-xl text-white mb-4 leading-relaxed" data-id="element-170">
            Our team has been trusted by some of the world's most respected
            organizations in healthcare…
          </h3>
          <LogoCarousel data-id="element-171" />
          <div className="mt-8" data-id="element-172">
            {scrollToCalendar ? <div className="flex justify-center" data-id="element-173">
                <div className="relative" data-id="element-174">
                  <div className="button-border-light" data-id="element-175"></div>
                  <motion.button onClick={scrollToCalendar} whileHover={{
                scale: 1.05,
                boxShadow: '0px 8px 20px rgba(255, 223, 7, 0.3)'
              }} className="relative z-10 bg-gradient-to-r from-[#ffdf07] via-[#fae651] to-[#ffdf07] text-black font-semibold py-3 px-8 sm:px-10 rounded-md text-base shadow-[0_4px_14px_rgba(255,223,7,0.25)] border border-[#ffd70077] transition-all duration-300" data-id="element-176">
                    Book My Strategy Call
                  </motion.button>
                </div>
              </div> : <ApplyButton data-id="element-177" />}
          </div>
        </motion.div>
      </div>
    </section>;
};
export default LogoSection;